import { z } from 'zod';

import { ZodTaigaId } from '@Common/types/b2b/axa/common';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodTransactionId = ZodTaigaId.or(ZodTrimmedString);
export type TransactionId = z.TypeOf<typeof ZodTransactionId>;
